
    import {computed, ComputedRef, defineComponent, reactive, watch, toRefs} from 'vue'
    import {useStore} from "@/store";
    import reportMsgUt from "@/util/reportMsg";
    import common from "@/util/common";
    import {useRoute, useRouter} from "vue-router";
    import { Popup } from 'scvant';
     import utils from '@/util/index';
    import circleCom from './circleCom.vue';

    interface State {
        reportCode: string;
        activeTab: number;
        blueCircleWidth: number;
        blueCircle: object;
        blueCircleList: Array<object>;
        greenCircleWidth: number;
        greenCircle: object;
        goodCircle: object;
        middleCircle: object;
        warnCircle: object;
        emptyCircle: object;
        greenCircleList: Array<object>;
        isShowBatteryPop: boolean;
        haveBatteryResult: number;

    }

    export default defineComponent({
        name: "nevsCard",
        props: {
            renderData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        setup(props: any) {
            let state: State = reactive({
                reportCode: '',
                activeTab: 0,
                blueCircleWidth: 8,
                greenCircleWidth: 8,
                isShowBatteryPop: false,
                haveBatteryResult: 1,
                blueCircle: {
                    name: 'checkModule', 
                    value: 'linear-gradient(90deg, #007DF3 0%, #0F3299 100%)',
                    id: 'gradient-checkModule',
                    backgroundColor: '#C2DFF5',
                    color1: '#007DF3',
                    color2: '#0F3299',
                },
                greenCircle: {
                    name: 'batteryCircle', 
                    value: 'linear-gradient(90deg, #25F2C4 0%, #02BE8C 100%)',
                    id: 'gradient-battery',
                    backgroundColor: '#C7F1E8',
                    color1: '#25F2C4',
                    color2: '#02BE8C',
                    contTxt: '优秀',
                },
                goodCircle: {
                    name: 'batteryCircle', 
                    value: 'linear-gradient(90deg, #1DECC1 0%, #00BCB8 100%)',
                    id: 'gradient-battery',
                    backgroundColor: '#C7F1E8',
                    color1: '#1DECC1',
                    color2: '#00BCB8',
                    contTxt: '良好',
                },
                middleCircle: {
                    name: 'batteryCircle', 
                    value: 'linear-gradient(90deg, #BDE664 0%, #EDCE0C 100%)',
                    id: 'gradient-battery',
                    backgroundColor: '#C7F1E8',
                    color1: '#BDE664',
                    color2: '#EDCE0C',
                    contTxt: '中等',
                },
                warnCircle: {
                    name: 'batteryCircle', 
                    value: 'linear-gradient(90deg, #EDC40D 0%, #EC570F 100%)',
                    id: 'gradient-battery',
                    backgroundColor: '#C7F1E8',
                    color1: '#EDC40D',
                    color2: '#EC570F',
                    contTxt: '一般',
                },
                emptyCircle: {
                    name: 'batteryCircle', 
                    value: 'linear-gradient(90deg, #EDC40D 0%, #EC570F 100%)',
                    id: 'gradient-battery',
                    backgroundColor: '#C7F1E8',
                    color1: '#EDC40D',
                    color2: '#EC570F',
                    contTxt: '-',
                },
                blueCircleList: [{
                    name: 'accidentCircle',
                    total: 0,
                    error: 0,
                    nameTxt: '事故项',
                    clickToId: 'accident',
                },{
                    name: 'fireCircle',
                    total: 0,
                    error: 0,
                    nameTxt: '火烧项',
                    clickToId: 'fire',
                },{
                    name: 'waterCircle',
                    total: 0,
                    error: 0,
                    nameTxt: '泡水项',
                    clickToId: 'soakWater',
                }],
                greenCircleList: [{
                    name: 'batteryHealthyCircle',
                    total: 100,
                    normal: 64,
                    type: 'normal',
                    nameTxt: '电池健康度',
                },{
                    name: 'safeWarn',
                    total: 5,
                    error: 2,
                    nameTxt: '安全隐患',
                },{
                    name: 'appearanceDamage',
                    total: 17,
                    error: 4,
                    nameTxt: '外观损伤',
                }],

            })
            const {renderData} = toRefs(props);
            function getData(code, key='value', type='') {
                return common.getDataByCode(renderData.value, code, key, type)
            } 
            // state.promiseTxt = `${getData('serviceOneTitleH5')}`;
            // state.showProtect = getData('rank') !== 'D';
            const accidentItems = getData('accidentItems').split('/');
            const fireItems = getData('fireItems').split('/');
            const waterItems = getData('waterItems').split('/');
            state.blueCircleList = [{
                name: 'accidentCircle',
                total: accidentItems[1],
                error: accidentItems[0],
                nameTxt: '事故项',
                clickToId: 'accident',
            },{
                name: 'fireCircle',
                total: fireItems[1],
                error: fireItems[0],
                nameTxt: '火烧项',
                clickToId: 'fire',
            },{
                name: 'waterCircle',
                total: waterItems[1],
                error: waterItems[0],
                nameTxt: '泡水项',
                clickToId: 'soakWater',
            }]
            const soh = Number(getData('soh'));
            const batterySafetyHazard = getData('batterySafetyHazard').split('/');
            const batteryAppearanceDamage = getData('batteryAppearanceDamage').split('/');
            state.greenCircleList = [{
                name: 'batteryHealthyCircle',
                total: 100,
                normal: soh,
                isEmpty: !soh,
                type: 'normal',
                nameTxt: '电池健康度',
                clickToId: 'batteryHealthy',
            },{
                name: 'safeWarn',
                total: batterySafetyHazard[1],
                error: batterySafetyHazard[0],
                nameTxt: '安全隐患',
                clickToId: 'batterySafety',
            },{
                name: 'appearanceDamage',
                total: batteryAppearanceDamage[1],
                error: batteryAppearanceDamage[0],
                nameTxt: '外观损伤',
                clickToId: 'batteryAppearance',
            }]
            function getElementToPageTop (el) {
                if (el.offsetParent) {
                    return getElementToPageTop(el.offsetParent) + el.offsetTop
                }
                else {
                    return el.offsetTop
                }
            }
            let store = useStore();
            // 获取路由器实例
            const router = useRouter()
            let reportData: ComputedRef<{}> = computed<{}>(() => store.state.reportData)
            watch(reportData, (data: any) => {
                const {haveBatteryResult} = JSON.parse(JSON.stringify(data));
                state.haveBatteryResult = haveBatteryResult;
            }, {immediate: true, deep: true})
            let isShowBatteryOtherMsg: ComputedRef<{}> = computed<{}>(() => {
                if (state.haveBatteryResult !== 1) {
                    return false;
                }
                return true;
            })
            return {
                state,
                router,
                isShowBatteryOtherMsg,
                getData,
                getElementToPageTop
            }
        },
        components: {
            circleCom,
            [Popup.name]: Popup,
        },
        methods: {
            clickTab(id) { // 点击tab切换
                const sTop = document.documentElement.scrollTop || document.body.scrollTop;
                const eTopEl: any = document.getElementById(id);
                const topNum = this.getElementToPageTop(eTopEl);
                console.log('id---', id, 'sTop---', sTop, 'topNum---', topNum, 'eTopEl---', eTopEl);
                utils.scrollTop(window, sTop, topNum - 60, 500);
            },
            changeBatteryPop() {
                this.state.isShowBatteryPop = !this.state.isShowBatteryPop;
            },
            setCircleGradient(item) {
                if (item.type === 'normal') {
                    if (item.isEmpty) {
                        item.normal = 64;
                        return this.state.emptyCircle;
                    } else {
                        if (item.normal >= 90) {
                            return this.state.greenCircle;
                        } else if (item.normal < 90 && item.normal >= 80) {
                            return this.state.goodCircle;
                        } else if (item.normal < 80 && item.normal >= 65) {
                            return this.state.middleCircle;
                        } else {
                            return this.state.warnCircle;
                        }
                    }
                } else {
                    return this.state.greenCircle;
                }
            },
            setProgress(item) {
                if (item.type === 'normal') {
                    return item.normal / item.total * 100;
                }
                return 100 - (item.error / item.total * 100);
            },
            changeTab(index) {
                this.state.activeTab = index;
            },
            toExplain() {
                let routerUrl = this.getData('serviceOneContentH5').replace('_','');
                routerUrl = routerUrl.charAt(0).toUpperCase() + routerUrl.slice(1);
                this.router.push({
                    path: `/batteryFrame${routerUrl}`,
                })
            }
        }
    })
